// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionSquareCards_container__pzx_x","backgroundOne":"SectionSquareCards_backgroundOne__rCKw_","backgroundTwo":"SectionSquareCards_backgroundTwo__WIphK"};